import BaseService from './base'

export default class RoleService extends BaseService {
  static resource() {
    return 'api/v1/roles'
  }
}
